import { render } from "./SpecialOrderLeadTime.vue?vue&type=template&id=b52bd03c&scoped=true"
import script from "./SpecialOrderLeadTime.vue?vue&type=script&lang=js"
export * from "./SpecialOrderLeadTime.vue?vue&type=script&lang=js"

import "./SpecialOrderLeadTime.vue?vue&type=style&index=0&id=b52bd03c&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52bd03c"]])

export default __exports__